export const BEFORE_SONG_UPLOADED = "Nothing Uploaded";
export const SONG_UPLOADED_LOCALLY = "Song Ready to Upload";
export const SONG_UPLOADED_TO_SERVER = "Uploaded";

/* LOAD SONGS */
export const LOAD_SONGS_BEGIN = "LOAD_SONGS_BEGIN";
export const loadSongsBegin = () => ({
  type: LOAD_SONGS_BEGIN,
});

export const LOAD_SONGS_FAILURE = "LOAD_SONGS_FAILURE";
export const loadSongsFailure = () => ({
  type: LOAD_SONGS_FAILURE,
});

export const LOAD_SONGS_SUCCESS = "LOAD_SONGS_SUCCESS";
export const loadSongsSuccess = (songs) => ({
  type: LOAD_SONGS_SUCCESS,
  songs,
});

/*ADD SONG */
export const ADD_SONG = "ADD_SONG";
export const addSong = () => ({
  type: ADD_SONG,
});

/* EDIT SONG NAME */
export const EDIT_SONG_NAME = "EDIT_SONG_NAME";
export const editSongName = (songName, uniqueName) => ({
  type: EDIT_SONG_NAME,
  songName,
  uniqueName,
});

/* EDIT UPLOAD STATUS */
export const EDIT_UPLOAD_STATUS = "EDIT_UPLOAD_STATUS";
export const editUploadStatus = (status, uniqueName) => ({
  type: EDIT_UPLOAD_STATUS,
  status,
  uniqueName,
});

/*SAVE SONG*/
export const SAVE_SONG_BEGIN = "SAVE_SONG_BEGIN";
export const saveSongBegin = (audioData, song, songToUpload, uniqueName) => ({
  type: SAVE_SONG_BEGIN,
  audioData,
  song,
  songToUpload,
  uniqueName,
});

export const SAVE_SONG_FAILURE = "SAVE_SONG_FAILURE";
export const saveSongFailure = (uniqueName) => ({
  type: SAVE_SONG_FAILURE,
  uniqueName,
});

export const SAVE_SONG_SUCCESS = "SAVE_SONG_SUCCESS";
export const saveSongSuccess = (
  songFilename,
  sampleStartByte,
  sampleEndByte,
  duration,
  fileSize,
  uniqueName,
  dateCreated,
  reviewStatus,
  url,
  ttl,
  firstSave,
  index
) => ({
  type: SAVE_SONG_SUCCESS,
  songFilename,
  sampleStartByte,
  sampleEndByte,
  duration,
  fileSize,
  uniqueName,
  dateCreated,
  reviewStatus,
  url,
  ttl,
  firstSave,
  index,
});

/*SAVE EVIDENCE*/
export const SAVE_EVIDENCE_BEGIN = "SAVE_EVIDENCE_BEGIN";
export const saveEvidenceBegin = (pictureData, uniqueName) => ({
  type: SAVE_EVIDENCE_BEGIN,
  pictureData,
  uniqueName
});

export const SAVE_EVIDENCE_SUCCESS = "SAVE_EVIDENCE_SUCCESS";
export const saveEvidenceSuccess = (uniqueName) => ({
  type: SAVE_EVIDENCE_SUCCESS,
  uniqueName
});

export const SAVE_EVIDENCE_FAILURE = "SAVE_EVIDENCE_FAILURE";
export const saveEvidenceFailure = (uniqueName) => ({
  type: SAVE_EVIDENCE_FAILURE,
  uniqueName
});

/*GET REVIEW STATES*/
export const GET_REVIEW_STATES_BEGIN = "GET_REVIEW_STATES_BEGIN";
export const getReviewStatesBegin = () => ({
  type: GET_REVIEW_STATES_BEGIN
});

export const GET_REVIEW_STATES_SUCCESS = "GET_REVIEW_STATES_SUCCESS";
export const getReviewStatesSuccess = (reviewStates) => ({
  type: GET_REVIEW_STATES_SUCCESS,
  reviewStates
});

/*REMOVE SONG (from frontend) */
export const REMOVE_SONG = "REMOVE_SONG";
export const removeSong = (uniqueName) => ({
  type: REMOVE_SONG,
  uniqueName,
});

/*DELETE SONG (from backend) */
export const DELETE_SONG_BEGIN = "DELETE_SONG_BEGIN";
export const deleteSongBegin = (uniqueName) => ({
  type: DELETE_SONG_BEGIN,
  uniqueName,
});

export const DELETE_SONG_FAILURE = "DELETE_SONG_FAILURE";
export const deleteSongFailure = (uniqueName) => ({
  type: DELETE_SONG_FAILURE,
  uniqueName
});

export const DELETE_SONG_SUCCESS = "DELETE_SONG_SUCCESS";
export const deleteSongSuccess = () => ({
  type: DELETE_SONG_SUCCESS,
});

/*SAMPLE EDITING*/
export const SAMPLE_EDIT = "SAMPLE_EDIT";
export const sampleEdit = (percentage, uniqueName, commit) => ({
  type: SAMPLE_EDIT,
  percentage,
  uniqueName,
  commit,
});
